/**
 * Created by Ivan on 29.12.2023
 */

const HorizontalBlockerNode = cc.Node.extend({
    ctor: function (node) {
        this._super();

        this.node = node;

        const alignment = cleverapps.clone(ComponentMap.get(this.node, AlignmentComponent).alignment, true);
        cleverapps.toArray(alignment).forEach((position) => {
            position.x = cleverapps.styles.HorizontalBlockerNode.x;
        });

        this.onResize();
        this.setAlignment(alignment);
    },

    onResize: function () {
        const scene = cleverapps.resolution.getSceneSize();
        this.setContentSize(scene.width, this.node.height);
    }
});

cleverapps.styles.HorizontalBlockerNode = {
    x: { align: "left" }
};